export default __webpack_public_path__ + "static/media/icon-bear.d5695f93.png";